import { ScanLine } from "lucide-react";
import { Link } from "react-router-dom";

export default function BrandHeader({ size = "md", showNS = true, testid = "brand-header" }) {
  const wordSize = size === "lg" ? "text-2xl" : size === "sm" ? "text-base" : "text-xl";
  const iconBox = size === "lg" ? "h-10 w-10" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const iconSize = size === "lg" ? "h-5 w-5" : size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  const nsSize = size === "lg" ? "h-10 w-10" : size === "sm" ? "h-6 w-6" : "h-9 w-9";

  return (
    <div className="flex items-center justify-between gap-3" data-testid={testid}>
      <Link to="/" className="flex items-center gap-2 hover:opacity-90 transition-opacity">
        <span className={`inline-flex ${iconBox} items-center justify-center rounded-lg bg-zinc-950 text-white`}>
          <ScanLine className={iconSize} strokeWidth={2.5} />
        </span>
        <span className={`font-display ${wordSize} font-black tracking-tight text-slate-900`}>ExpoLead</span>
      </Link>
      
      {showNS && (
        <div className="flex items-center gap-2">
         
          <span className="hidden sm:inline-block font-display text-[10px] font-black tracking-[0.15em] text-zinc-700 uppercase">
          
          </span>
        </div>
      )}
    </div>
  );
}